export enum RuleSharePermissionsEnum {
    CAN_VIEW = 'can-view',
    CAN_EDIT = 'can-edit',
    CAN_DUPLICATE = 'can-duplicate'
}